module.exports = __webpack_public_path__ + "img/instagram.892b969c.svg";